import { MenuItem, TextField } from "@mui/material";
import { useEffect } from "react";
//import PropTypes from "prop-types";
import classes from "../CustomInputs.module.css";
import { InputInfo } from "../../../../entities/UIEntities/Form Entities/InputInfo";

const SelectInput = (props) => {
  useEffect(() => {
    if (props.handleError) {
      props.handleError({ [props.id]: props.hasError });
    }
    if (props.handleInputInfo) {
      props.handleInputInfo(new InputInfo(props.id, props.value, props.isRequired, props.hasError));
    }
  }, [props.value]);

  const handleChange = (event) => {
    const { name, value } = event.target ? event.target : event;
    props.onChange({ [name]: value });
  };

  return (
    <div className={classes.customTextField}>
      <TextField
        fullWidth
        select
        label={props.label}
        id={props.id}
        name={props.id}
        className={classes.textField}
        sx={props.sx}
        defaultValue={props.value}
        value={props.value ?? ''}
        onChange={handleChange}
        error={props.isStepSubmitted && props.hasError}
        helperText={
          props.isStepSubmitted && props.hasError ? props.errorMessage : ""
        }
        InputLabelProps={{ shrink: true }}
        InputProps={{
          classes: {
            notchedOutline: classes.filed
          },
        }}
        FormHelperTextProps={{
          classes: {
            error: classes.error,
          },
        }}
        SelectProps={{
          multiple: props.multiple,
          renderValue: props.renderValue,
          MenuProps: {
            classes: {
              list: classes.menuPaper,
              paper: props.paperClass
            }
          },
        }}
      >
        {props.list?.map((option) => (
          <MenuItem key={option.id} value={option.value} classes={{root: classes.option}}>
            <div>
              <span className={classes.selectedOption}>{option.label}</span>
            </div>
            
            {props.optionIcon && props.value.includes(option.value) && <img src={props.optionIcon} />}
          </MenuItem>
        ))}
      </TextField>
    </div>
  );
};

// SelectInput.propTypes ={
//   id: PropTypes.number ,
//   value: PropTypes.string,
//   hasError: PropTypes.string,
//   label: PropTypes.string,
//   onChange: PropTypes.object,
//   isStepSubmitted: PropTypes.bool,
//   errorMessage: PropTypes.string,
//   list: PropTypes.object,
// } 

export default SelectInput;
